module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-6-f3c91414b35fe55d2c150f146fa336e3.webp";